module.exports = __webpack_public_path__ + "static/img/qywx.870e430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qywx.png
// module id = VDow
// module chunks = 0